var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "lg",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "use-panel": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _vm.studentData
        ? _c("div", { staticClass: "evl-detail" }, [
            _c("div", { staticClass: "sk-panel evl-detail-student-panel" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-user" }),
                ]),
                _c("div", { staticClass: "sk-panel-info" }, [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v(_vm._s(_vm.studentData.studentName)),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(_vm._s(_vm.yearMonthDisplay)),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "evl-detail-content-wrap sk-u-mt-12" }, [
              _vm.detailTab === "daily"
                ? _c(
                    "div",
                    [
                      _vm.dailyEvaluations.length === 0
                        ? _c("div", { staticClass: "evl-detail-empty" }, [
                            _c("i", { staticClass: "el-icon-document" }),
                            _c("span", [_vm._v("Chưa có dữ liệu nhận xét")]),
                          ])
                        : _vm._e(),
                      _vm._l(_vm.dailyEvaluations, function (item) {
                        return _c(
                          "div",
                          { key: item.uid, staticClass: "evl-detail-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "evl-detail-card__header" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "evl-header-left" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "evl-date-tag",
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-date",
                                        }),
                                        _vm._v(
                                          " Ngày " +
                                            _vm._s(
                                              _vm._f("formatDate")(item.date)
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticClass: "evl-detail-teacher" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-user-solid",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.teacherName ||
                                            item.createdBy ||
                                            "Giáo viên"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            item.items && item.items.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "evl-category-grid" },
                                  _vm._l(item.items, function (catItem, cIdx) {
                                    return _c(
                                      "div",
                                      {
                                        key: catItem.categoryId || cIdx,
                                        staticClass: "evl-cat-card",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "evl-cat-card__header",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "evl-cat-card__title",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "evl-cat-dot",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "evl-cat-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        catItem.categoryName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "evl-cat-card__body" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "evl-cat-content-text",
                                              },
                                              [_vm._v(_vm._s(catItem.content))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : item.content
                              ? _c(
                                  "div",
                                  { staticClass: "evl-single-content-card" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "evl-single-content-header",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-edit-outline",
                                        }),
                                        _c("span", [
                                          _vm._v("Nội dung nhận xét"),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "evl-single-content-body",
                                      },
                                      [_vm._v(_vm._s(item.content))]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            item.files && item.files.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "evl-detail-files-section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "evl-detail-files-title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-paperclip",
                                        }),
                                        _vm._v(
                                          " File & hình ảnh đính kèm (" +
                                            _vm._s(item.files.length) +
                                            ")\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "evl-detail-files-list" },
                                      _vm._l(item.files, function (file, fIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: fIdx,
                                            staticClass: "evl-detail-file-chip",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openFilePreview(
                                                  item.files
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.isImageFile(file)
                                                ? "el-icon-picture"
                                                : "el-icon-document",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "evl-file-chip-name",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.getFileName(file))
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-view evl-file-chip-action",
                                            }),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            item.replies
                              ? _c("div", { staticClass: "evl-replies" }, [
                                  _c(
                                    "p",
                                    { staticClass: "evl-replies__title" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-chat-dot-round",
                                      }),
                                      _vm._v(
                                        " Phản hồi (" +
                                          _vm._s(item.replies.length) +
                                          ")\n            "
                                      ),
                                    ]
                                  ),
                                  item.replies.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "evl-reply-list" },
                                        _vm._l(item.replies, function (reply) {
                                          return _c(
                                            "div",
                                            {
                                              key: reply.uid,
                                              staticClass: "evl-reply-item",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "evl-reply-item__meta",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "evl-reply-item__name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          reply.replierName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        size: "mini",
                                                        type: _vm.roleTagType(
                                                          reply.role
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.roleLabel(
                                                            reply.role
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "evl-reply-item__date",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(reply.createdDate)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "evl-reply-item__content",
                                                },
                                                [_vm._v(_vm._s(reply.content))]
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "evl-add-reply" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder:
                                      "Viết phản hồi cho nhận xét này...",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.handleAddReply(item)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-s-promotion",
                                                loading:
                                                  _vm.replyLoading === item.uid,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleAddReply(
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.replyContents[item.uid],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.replyContents, item.uid, $$v)
                                    },
                                    expression: "replyContents[item.uid]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm.detailTab === "weekly"
                ? _c(
                    "div",
                    [
                      _vm.weeklyEvaluations.length === 0
                        ? _c("div", { staticClass: "evl-detail-empty" }, [
                            _c("i", { staticClass: "el-icon-document" }),
                            _c("span", [_vm._v("Chưa có dữ liệu nhận xét")]),
                          ])
                        : _vm._e(),
                      _vm._l(_vm.weeklyEvaluations, function (item) {
                        return _c(
                          "div",
                          { key: item.uid, staticClass: "evl-detail-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "evl-detail-card__header" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "evl-header-left" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "evl-date-tag",
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-date",
                                        }),
                                        _vm._v(
                                          " Tuần " +
                                            _vm._s(item.weekNumber) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "evl-date-range" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDate")(item.fromDate)
                                          ) +
                                            " – " +
                                            _vm._s(
                                              _vm._f("formatDate")(item.toDate)
                                            )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticClass: "evl-detail-teacher" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-user-solid",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.teacherName ||
                                            item.createdBy ||
                                            "Giáo viên"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "evl-single-content-card" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "evl-single-content-header" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit-outline",
                                    }),
                                    _c("span", [
                                      _vm._v("Nội dung nhận xét tuần"),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "evl-single-content-body" },
                                  [_vm._v(_vm._s(item.content))]
                                ),
                              ]
                            ),
                            item.files && item.files.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "evl-detail-files-section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "evl-detail-files-title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-paperclip",
                                        }),
                                        _vm._v(
                                          " File & hình ảnh đính kèm (" +
                                            _vm._s(item.files.length) +
                                            ")\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "evl-detail-files-list" },
                                      _vm._l(item.files, function (file, fIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: fIdx,
                                            staticClass: "evl-detail-file-chip",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openFilePreview(
                                                  item.files
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.isImageFile(file)
                                                ? "el-icon-picture"
                                                : "el-icon-document",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "evl-file-chip-name",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.getFileName(file))
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-view evl-file-chip-action",
                                            }),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            item.replies
                              ? _c("div", { staticClass: "evl-replies" }, [
                                  _c(
                                    "p",
                                    { staticClass: "evl-replies__title" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-chat-dot-round",
                                      }),
                                      _vm._v(
                                        " Phản hồi (" +
                                          _vm._s(item.replies.length) +
                                          ")\n            "
                                      ),
                                    ]
                                  ),
                                  item.replies.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "evl-reply-list" },
                                        _vm._l(item.replies, function (reply) {
                                          return _c(
                                            "div",
                                            {
                                              key: reply.uid,
                                              staticClass: "evl-reply-item",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "evl-reply-item__meta",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "evl-reply-item__name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          reply.replierName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        size: "mini",
                                                        type: _vm.roleTagType(
                                                          reply.role
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.roleLabel(
                                                            reply.role
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "evl-reply-item__date",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(reply.createdDate)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "evl-reply-item__content",
                                                },
                                                [_vm._v(_vm._s(reply.content))]
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "evl-add-reply" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder:
                                      "Viết phản hồi cho nhận xét này...",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.handleAddReply(item)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-s-promotion",
                                                loading:
                                                  _vm.replyLoading === item.uid,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleAddReply(
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.replyContents[item.uid],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.replyContents, item.uid, $$v)
                                    },
                                    expression: "replyContents[item.uid]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm.detailTab === "monthly"
                ? _c(
                    "div",
                    [
                      _vm.monthlyEvaluations.length === 0
                        ? _c("div", { staticClass: "evl-detail-empty" }, [
                            _c("i", { staticClass: "el-icon-document" }),
                            _c("span", [_vm._v("Chưa có dữ liệu nhận xét")]),
                          ])
                        : _vm._e(),
                      _vm._l(_vm.monthlyEvaluations, function (item) {
                        return _c(
                          "div",
                          { key: item.uid, staticClass: "evl-detail-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "evl-detail-card__header" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "evl-header-left" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "evl-date-tag",
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-date",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.yearMonthDisplay || "Tháng"
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticClass: "evl-detail-teacher" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-user-solid",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.createdBy ||
                                            item.teacherName ||
                                            "Giáo viên"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "evl-single-content-card" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "evl-single-content-header" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit-outline",
                                    }),
                                    _c("span", [
                                      _vm._v("Nội dung nhận xét tháng"),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "evl-single-content-body" },
                                  [_vm._v(_vm._s(item.content))]
                                ),
                              ]
                            ),
                            item.files && item.files.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "evl-detail-files-section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "evl-detail-files-title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-paperclip",
                                        }),
                                        _vm._v(
                                          " File & hình ảnh đính kèm (" +
                                            _vm._s(item.files.length) +
                                            ")\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "evl-detail-files-list" },
                                      _vm._l(item.files, function (file, fIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: fIdx,
                                            staticClass: "evl-detail-file-chip",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openFilePreview(
                                                  item.files
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.isImageFile(file)
                                                ? "el-icon-picture"
                                                : "el-icon-document",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "evl-file-chip-name",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.getFileName(file))
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-view evl-file-chip-action",
                                            }),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            item.replies && item.replies.length > 0
                              ? _c("div", { staticClass: "evl-replies" }, [
                                  _c(
                                    "p",
                                    { staticClass: "evl-replies__title" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-chat-dot-round",
                                      }),
                                      _vm._v(
                                        " Phản hồi (" +
                                          _vm._s(item.replies.length) +
                                          ")\n            "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "evl-reply-list" },
                                    _vm._l(item.replies, function (reply) {
                                      return _c(
                                        "div",
                                        {
                                          key: reply.uid,
                                          staticClass: "evl-reply-item",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "evl-reply-item__meta",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "evl-reply-item__name",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(reply.replierName)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: _vm.roleTagType(
                                                      reply.role
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.roleLabel(reply.role)
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "evl-reply-item__date",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDateTime")(
                                                        reply.createdDate
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "evl-reply-item__content",
                                            },
                                            [_vm._v(_vm._s(reply.content))]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "evl-add-reply" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder:
                                      "Viết phản hồi cho nhận xét này...",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.handleAddReply(item)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-s-promotion",
                                                loading:
                                                  _vm.replyLoading === item.uid,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleAddReply(
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.replyContents[item.uid],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.replyContents, item.uid, $$v)
                                    },
                                    expression: "replyContents[item.uid]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _c("EvaluationFilePreviewDialog", { ref: "filePreviewDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }